import { isRoleAllowed } from 'dashboard/helper/permissionsHelper';

export const isSidebarItemVisible = (
  menuItem,
  {
    accountId,
    account = {},
    currentRole = null,
    globalConfig = {},
    isEnterprise = false,
    isFeatureEnabledonAccount,
    isNewFeatureFlagEnabled,
  } = {}
) => {
  const isVisible = resolveBaseVisibility(menuItem, {
    accountId,
    globalConfig,
    isEnterprise,
    isFeatureEnabledonAccount,
    isNewFeatureFlagEnabled,
  });

  // Independent of the flag-based gates above: an item can additionally be
  // restricted to whichever roles are listed in the account field named by
  // `allowedRolesField` (e.g. `report_builder_legacy_allowed_roles`), so a
  // role excluded there never sees the entry point at all — not even to hit
  // the backend gate and get a "failed to load" error.
  if (isVisible && menuItem.allowedRolesField) {
    return isRoleAllowed(currentRole, account?.[menuItem.allowedRolesField] ?? []);
  }

  return isVisible;
};

const resolveBaseVisibility = (
  menuItem,
  { accountId, globalConfig, isEnterprise, isFeatureEnabledonAccount, isNewFeatureFlagEnabled }
) => {
  if (menuItem.globalConfigFlag) {
    return !!globalConfig[menuItem.globalConfigFlag];
  }

  const isFeatureEnabled = menuItem.featureFlag
    ? !!isFeatureEnabledonAccount(accountId, menuItem.featureFlag)
    : true;

  if (menuItem.newFeatureFlag) {
    const isEnabled = !!isNewFeatureFlagEnabled(menuItem.newFeatureFlag);
    return menuItem.hideIfFeatureFlag ? !isEnabled : isEnabled;
  }

  if (menuItem.isEnterpriseOnly) {
    return isEnterprise && (isFeatureEnabled || !!globalConfig.displayManifest);
  }

  return isFeatureEnabled;
};

export const withSectionTitles = (menuItems, isVisible) => {
  let openSection;
  return menuItems.map(menuItem => {
    if (!isVisible(menuItem)) return menuItem;
    if (menuItem.section === openSection) return menuItem;
    openSection = menuItem.section;
    if (!menuItem.section) return menuItem;
    return { ...menuItem, sectionTitle: menuItem.section };
  });
};
